import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AppShell from '../components/AppShell';

/** 服務條款（Meta App → Live 要求：Basic Settings 的 Terms of Service URL） */
const SECTIONS = ['accept', 'account', 'conduct', 'content', 'liability', 'changes', 'contact'] as const;

export default function TermsPage() {
  const { t } = useTranslation();
  return (
    <AppShell title={t('terms_title')}>
      <div className="p-6 max-w-2xl mx-auto text-sm leading-relaxed">
        <h1 className="text-xl font-bold mb-1">{t('terms_title')}</h1>
        <p className="mb-5 text-xs" style={{ color: 'var(--color-text-secondary)' }}>
          {t('legal_updated')}
        </p>
        <p className="mb-5" style={{ color: 'var(--color-text-secondary)' }}>
          {t('terms_intro')}
        </p>
        {SECTIONS.map((s) => (
          <section key={s} className="mb-5">
            <h2 className="font-semibold mb-1">{t(`terms_${s}_h`)}</h2>
            <p style={{ color: 'var(--color-text-secondary)' }}>{t(`terms_${s}`)}</p>
          </section>
        ))}
        <div className="mt-8 flex flex-wrap gap-4">
          <Link to="/privacy" style={{ color: 'var(--color-primary)' }}>
            {t('footer_privacy')}
          </Link>
          <Link to="/data-deletion" style={{ color: 'var(--color-primary)' }}>
            {t('footer_deletion')}
          </Link>
          <Link to="/" style={{ color: 'var(--color-primary)' }}>
            {t('back_home')}
          </Link>
        </div>
      </div>
    </AppShell>
  );
}
